import { AxiosError } from 'axios';
import { Auth, IAuthResponse } from '../Auth';
import { AuthProvider } from './AuthProvider';

export type BrokerageAuthParameter = {
  email: string;
  password: string;
  product: string;
};
export class BrokerageLogin extends AuthProvider<BrokerageAuthParameter> {
  constructor(auth: Auth) {
    super(auth);
  }

  public login(credentials: BrokerageAuthParameter): Promise<boolean> {
    this.validateConfig();
    const startTime = Date.now();
    return this.auth
      .request({
        url: this.auth.Config.userPortal.url,
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        timeout: this.auth.RequestTimeout,
        data: {
          email: credentials.email,
          password: credentials.password,
          product: credentials.product,
          forceLogin: true,
          fetchToken: true,
        },
      })
      .then((response: IAuthResponse) =>
        this.createSession(response, credentials.email, Date.now() - startTime)
      )
      .then(this.getTokenFromCredentials.bind(this))
      .then(() => true)
      .catch((error: AxiosError) => {
        this.logout().then(() => true);
        return Promise.reject(error);
      });
  }
}
